import { Div, Variable, A, Span } from 'alkali'
import './Chip.scss'
import Icon from 'components/Icon'
import * as closeIcon from 'icons/close.svg'

interface ChipObject {
	icon?: any
	name?: Variable<string> | String
	docSearchLink?: String
	onClose?: Function
}

export const Chip = Div.with('.chip', {
	tabIndex: -1,
	created(properties) {
		const chip: ChipObject = properties
		this.append(
			new (chip.docSearchLink ? A : Span)(
				'.chip-name',
				{
					href: `https://search.doctorevidence.com/search?query=${chip.docSearchLink}`,
					target: '_blank',
					rel: 'noopener',
					title: `${chip.name}`
				},
				[Div('.chip-icon', [`${chip.icon}`]), Div('.vertical-line'), `${chip.name}`]
			),
			new Icon('.chip-close', {
				icon: closeIcon,
				title: 'Close this toast',
				tabIndex: 0,
				onclick: chip.onClose,
			})
		)
	},
})
